import { useVisiblePoll } from "@/hooks/useVisiblePoll";
import { useItemsStore } from "./itemsStore";

/**
 * How often an open editor re-checks the server for changes with no other
 * signal (price-model propagation, ERP sync, other users).
 */
const REVALIDATE_INTERVAL_MS = 30000;

/**
 * Polls the item's nested hydration while an editor is open, pausing when the
 * tab is hidden and refetching immediately on resume. Safe mid-edit: the
 * store's monotonic guard and the draft overlay keep background refreshes
 * from clobbering local edits.
 */
export function useItemRevalidationPoll(itemId: string | null): void {
  const fetchItem = useItemsStore((state) => state.fetchItem);
  useVisiblePoll(
    () => {
      if (itemId) {
        fetchItem(itemId, true);
      }
    },
    REVALIDATE_INTERVAL_MS,
    itemId !== null,
  );
}
